import { Image } from '@app/components'
import React from 'react'

export const SignInGraphic: React.FC<{ height?: number }> = ({ height = 400 }) => {
  return <Image preview={false} src="../images/Sign-In-Graphic.png" style={{ height }} />
}
